import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Field, Form } from 'react-final-form'
import {
  IconButton,
  Button,
  FormControl,
  FormControlLabel,
  Typography,
} from '@material-ui/core'
import IconBack from '@material-ui/icons/ArrowBack'
import { injectIntl } from 'react-intl'
import withPromise from 'helpers/withPromise'
import { Checkbox } from 'components/common/FormInputs'
import Input from 'components/common/Form/Input'
import getValidator, { VALIDATOR_IS_EMPTY } from 'validation'
import {
  fetchLocusGroupForm,
  setLocusGroupInfo,
  clearLocusGroupStore,
} from 'reducers/locusGroup/reducer'
import Loader from 'components/Loading'
import { REACT_INTL_PROP_TYPE } from 'constants/propTypes'
import messages from './translate'
import DependentSelectLists from './DependentSelectLists'

class LocusGroupForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect: false,
    }
  }

  componentDidMount() {
    const { fetchLocusGroupForm } = this.props

    fetchLocusGroupForm({
      entityId: this.getEntityId(),
    })
  }

  componentDidUpdate() {
    const {
      history: { goBack },
    } = this.props
    const { redirect } = this.state

    if (redirect) {
      goBack()
    }
  }

  componentWillUnmount() {
    const { clearLocusGroupStore } = this.props

    clearLocusGroupStore()
  }

  getEntityId() {
    const {
      match: {
        params: { id },
      },
    } = this.props

    return id !== 'create' ? id : false
  }

  onSubmit = values => {
    const { setLocusGroupInfo } = this.props

    return withPromise(setLocusGroupInfo, {
      entityId: this.getEntityId(),
      values,
    }).then(errors =>
      errors
        ? Promise.resolve(errors)
        : this.setState({
            redirect: true,
          }),
    )
  }

  getFormData = entity => {
    const formData = {
      name: '',
      site: '',
      locuses: [],
      visibleInUi: false,
    }

    if (entity) {
      const { name, site, locuses, visibleInUi } = entity
      formData.name = name
      formData.site = site.id
      formData.locuses = locuses.map(locus => locus.id)
      formData.visibleInUi = visibleInUi
    }

    return formData
  }

  render() {
    const {
      isLoadForm,
      formData,
      intl: { formatMessage },
      history: { goBack },
    } = this.props
    const { sites, locusGroup } = formData.toJS()
    const entityData = this.getFormData(locusGroup)

    if (isLoadForm) {
      return <Loader pastDelay />
    }

    return (
      <div className="container-fluid no-breadcrumb">
        <Typography variant="h5" className="headline">
          <IconButton size="medium" className="btn-back" onClick={goBack}>
            <IconBack fontSize="small" />
          </IconButton>
          {formatMessage(messages.unitGroupInfo)}
        </Typography>
        <Form
          onSubmit={this.onSubmit}
          initialValues={entityData}
          mutators={{
            setSite: ([value], state, { changeValue }) => {
              changeValue(state, 'site', () => value)
            },
            setLocuses: ([value], state, { changeValue }) => {
              changeValue(state, 'locuses', () => value)
            },
          }}
          render={({
            handleSubmit,
            submitting,
            pristine,
            values,
            submitFailed,
            errors: { site, locuses },
            form: { mutators },
          }) => (
            <form onSubmit={handleSubmit} className="form-basic">
              <Field
                required
                name="name"
                type="text"
                label={formatMessage(messages.name)}
                component={Input}
                disabled={submitting}
                validate={getValidator(VALIDATOR_IS_EMPTY)}
              />
              <Field
                required
                name="site"
                type="hidden"
                component={() => null}
                validate={getValidator(VALIDATOR_IS_EMPTY)}
              />
              <Field name="locuses" type="hidden" component={() => null} />
              <DependentSelectLists
                siteList={sites}
                siteValue={values.site}
                siteError={submitFailed && (site || null)}
                setSite={mutators.setSite}
                locusesValue={values.locuses}
                locusesError={submitFailed && (locuses || null)}
                setLocuses={mutators.setLocuses}
              />
              <FormControl fullWidth component="div" className="form-group">
                <FormControlLabel
                  label={formatMessage(messages.visibleInUi)}
                  disabled={submitting}
                  className="form-group"
                  control={
                    <Field
                      name="visibleInUi"
                      component={Checkbox}
                      type="checkbox"
                      color="primary"
                    />
                  }
                />
              </FormControl>
              <div className="form-group buttons">
                <Button
                  href={null}
                  type="submit"
                  color="primary"
                  size="medium"
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={submitting || pristine}>
                  {formatMessage(messages.saveInfo)}
                </Button>
              </div>
            </form>
          )}
        />
      </div>
    )
  }
}

LocusGroupForm.propTypes = {
  isLoadForm: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  intl: REACT_INTL_PROP_TYPE.isRequired,
  fetchLocusGroupForm: PropTypes.func,
  setLocusGroupInfo: PropTypes.func,
  clearLocusGroupStore: PropTypes.func,
}

LocusGroupForm.defaultProps = {
  fetchLocusGroupForm: () => {},
  setLocusGroupInfo: () => {},
  clearLocusGroupStore: () => {},
}

export default connect(
  state => ({
    isLoadForm: state.getIn(['locusGroup', 'isLoadForm']),
    formData: state.getIn(['locusGroup', 'formData']),
  }),
  {
    fetchLocusGroupForm,
    setLocusGroupInfo,
    clearLocusGroupStore,
  },
)(injectIntl(LocusGroupForm))
